import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import axios from "axios";
import Social from "../../components/social/social";
import Header from "../../components/header/header";
import Events from "../../components/events/events";
import "./home.scss"

const Home = () => {

    const [header, setHeader] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {

        const fetchData = async () => {
            try {

                const headerRes = await axios.get(`https://mk-lorenzen.it/admin/wp-json/wp/v2/header`);
                if (headerRes.data && headerRes.data.length > 0) {
                    setHeader(headerRes.data);
                }

                setLoading(false);
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="home">
            <Helmet>
                <title>Musikkapelle St. Lorenzen | Die älteste Musikkapelle im Pustertal</title>
            </Helmet>
            {isLoading ? <div className="header" /> : <Header images={header} />}
            <div className="about">
                <div className="container">
                    <motion.div
                        className="left"
                        initial={{ opacity: 0, y: 100 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <p>Die Musikkapelle St.Lorenzen besteht seit 1818 und ist somit die älteste Kapelle des Pustertals.</p>
                        <p>Die organisatorischen Geschicke der Musikkapelle St. Lorenzen leitet seit dem Jahr 2025 Obmann Alexander Niederegger. Die musikalische Leitung obliegt seit dem Jahr 2019 Jakob Augschöll aus Luttach.</p>
                        <Link className="mitglieder" to={"/kapelle"}>
                            <button>Zur Kapelle</button>
                            <img src="https://mk-lorenzen.it/admin/wp-content/uploads/2024/11/MKSTL-Final_Edit-scaled.jpg" alt="Gruppenfoto" />
                            <div className="stampDiv">
                                <img src="/assets/stamp.png" className="stamp" alt="Stempel" />
                            </div>
                        </Link>
                    </motion.div>
                    <motion.div
                        className="right"
                        initial={{ opacity: 0, y: 200 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                        <img src="https://mk-lorenzen.it/admin/wp-content/uploads/2024/11/MTN06364-scaled.jpg" alt="" />
                    </motion.div>
                </div>
            </div>
            <motion.div
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
            >
                <Events />
            </motion.div>
            <motion.div
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
            >
                <Social />
            </motion.div>
        </div>
    )
};

export default Home